import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { ControlPanel } from 'src/states/control-panel.actions';

@Component({
  selector: 'app-startup',
  templateUrl: './startup.component.html',
  styleUrls: ['./startup.component.css']
})
export class StartupComponent implements OnInit {

  constructor(private store: Store) { }

  ngOnInit() {
    this.store.dispatch(new ControlPanel.LoginRedirect());
  }

}
